'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = getFutureDeliveryDefaultTime;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _FirstValue = require('../../FirstValue');

var _FirstValue2 = _interopRequireDefault(_FirstValue);

var _availability = require('availability');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var conjunct = _availability.iteratorFactory.conjunct,
    disjunct = _availability.iteratorFactory.disjunct;


var earliestMinutesAllowed = 10;

function getFutureDeliveryDefaultTime(moment, organization) {
    var result = void 0;
    var deliveryInfos = _lodash2.default.filter(organization.deliveryInfos, function (di) {
        return !di.inactive;
    });

    result = (0, _FirstValue2.default)().bind(function () {
        return tryByMinimumDelay(deliveryInfos, organization.openTimes, moment);
    }).bind(function () {
        return tryByEarliestAvailability(deliveryInfos, organization.openTimes, moment);
    }).val();

    result = result || moment();
    result = clampByOrganizationFutureDelayMins(organization, result, moment);
    result = earliestRestriction(result, moment);
    return result;

    function earliestRestriction(time, moment) {
        return _lodash2.default.maxBy([moment().add(earliestMinutesAllowed, 'm'), time]);
    }

    function clampByOrganizationFutureDelayMins(org, time, moment) {
        var min = _lodash2.default.get(org, 'orders.future.delayMins.min');
        var max = _lodash2.default.get(org, 'orders.future.delayMins.max');

        if (time.diff(moment(), 'minutes') > max) time = moment();else if (time.diff(moment(), 'minutes') < min + 10) {
            time = moment().add(min + 10, 'minutes');
        }

        return time;
    }

    function tryByMinimumDelay(deliveryInfos, openTimes, moment) {
        var minDelayAvailable = getMinimalDelay(deliveryInfos, openTimes, moment());

        if (minDelayAvailable > 0) {
            return moment().add(minDelayAvailable, "m");
        }
    }

    function tryByEarliestAvailability(deliveryInfos, openTimes, moment) {
        var availabilities = _lodash2.default.map(deliveryInfos, function (di) {
            return di.availability;
        });
        var conjuncted = conjunct(disjunct(availabilities), openTimes);
        var earliest = conjuncted(moment()).next();
        var result = void 0;

        if (earliest.status === 'available') {
            var hourAhead = moment().add(1, "h");
            var earliest2 = conjuncted(hourAhead).next();

            if (earliest2.status === 'available') {
                result = hourAhead;
            } else if (earliest.until > 0) {
                result = moment(earliest2.until);
            }
        } else if (earliest.until > 0) {
            result = moment(earliest.until);
        }

        return result;
    }

    function getMinimalDelay(deliveryInfos, openTimes, from) {
        var typeMinDelay = (0, _lodash2.default)(deliveryInfos).filter(function (di) {
            return di.delayMins > 0;
        }).groupBy(function (di) {
            return di.type;
        }).map(function (deliveryInfos) {
            return getMinimal(deliveryInfos, openTimes, from);
        }).filter(function (di) {
            return di.available;
        }).map(function (di) {
            return di.delayMins;
        }).min();

        if (typeMinDelay === Infinity) //lodash bug - min returns Infinity on empty arr
            typeMinDelay = null;

        return typeMinDelay;
    }

    function getMinimal(deliveryInfos, openTimes, from) {
        var di = _lodash2.default.minBy(deliveryInfos, function (di) {
            return di.delayMins;
        });
        var status = conjunct(di.availability, openTimes)(from).next();

        var result = (0, _extends3.default)({}, di, {
            available: status.status === 'available'
        });

        return result;
    }
}